import React, { useState, useEffect } from "react";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../components/DeleteBlogModal";
import { apiRequestHandler } from "../../apiConfig/service";
import { toast } from "react-toastify";
import { url } from "../../apiConfig/ApiConfig";
import { formatDate } from "../../utils/formatedDate";
import DataTable from "react-data-table-component";
import Loader from "../../components/Loader";

const getAllBlogs = async (endPoint, token) => {
  const res = await apiRequestHandler({ endPoint, headers: { Authorization: `Bearer ${token}` } });
  return res?.data;
};

const BlogManagement = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [blogToDelete, setBlogToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const fetchBlogs = async () => {
    setIsLoading(true);
    try {
      const res = await getAllBlogs('getBlog', localStorage.getItem('token'));
      if (res) {
        const sortedData = res.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setBlogs(sortedData);
      } else {
        toast.error('Failed to fetch blogs');
      }
    } catch (error) {
      toast.error('Error while fetching blogs');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  useEffect(() => {
    const filtered = blogs?.filter(blog =>
      blog.title.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];
    setFilteredBlogs(filtered);
  }, [searchTerm, blogs]);

  const handleDeleteBlog = async (id) => {
    try {
      setIsLoading(true);
      const res = await apiRequestHandler({
        method: 'DELETE',
        endPoint: `${url}/blog/${id}`,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      if (res?.success) {
        toast.success(res.message);
        fetchBlogs();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error('Something went wrong');
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      name: 'Sr No.',
      selector: (row, index) => (currentPage - 1) * 10 + index + 1,
      width: '80px',
    }
    ,
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
      // width: "20%",
    },
    {
      name: "Short Description",
      selector: (row) => row.shortDescription,
      sortable: true,
      // width: "30%",

    },
    {
      name: "Created At",
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
      // width: "20%",

    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <FaEye
            title="View"
            style={{ color: '#064a8c', marginRight: "10px", cursor: "pointer" }}
            onClick={() => navigate("/admin/add-blog", { state: { blog: row, mode: "view" } })}
          />
          <FaEdit
            title="Edit"
            style={{ color: "#ff9800", marginRight: "10px", cursor: "pointer" }}
            onClick={() => navigate("/admin/add-blog", { state: { blog: row, mode: "edit" } })}
          />
          <FaTrash
            title="Delete"
            style={{ color: "#f44336", cursor: "pointer" }}
            onClick={() => {
              setBlogToDelete(row);
              setShowDeleteModal(true);
            }}
          />
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div style={{ minHeight: "100vh", padding: "20px", background: "#f5f7fa" }}>
      <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "10px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <h4 style={{ margin: 0 }}>Blog Management</h4>
          <button
            onClick={() => navigate("/admin/add-blog")}
            style={{
              background: "linear-gradient(to bottom right, #163252, #0081ff)",
              color: "#fff",
              border: "none",
              padding: "8px 16px",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            + Add Blog
          </button>
        </div>

        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          theme="dark"
          onConfirm={() => {
            handleDeleteBlog(blogToDelete?._id);
            setShowDeleteModal(false);
          }}
        />
      </div>

      <div className="modifyTable" style={{ borderRadius: "10px", marginTop: "20px" }}>
        <DataTable
          title=""
          columns={columns}
          data={filteredBlogs}
          pagination
          onChangePage={setCurrentPage}
          paginationDefaultPage={currentPage}
          highlightOnHover
          responsive
          striped
          progressPending={isLoading}
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Search by blog title..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                fontSize: "14px",
                width: "250px",
              }}
            />
          }
        />
      </div>
    </div>
  );
};

export default BlogManagement;
